import type { JSX } from 'react';
import type { Me } from '../auth/use-me';
import { monoLabel } from '../shell/look';
import { NEW_WORKSPACE_EVENT } from './workspace-form';
import { useSelectWorkspace } from './use-workspaces';

const item =
  'hover:bg-surf2 flex items-center justify-between gap-2 rounded-[7px] border-0 bg-transparent px-2.5 py-[9px] text-left text-[13.5px]';

/** The user menu's workspace part: where the panel is, the others, and a new one. */
export function WorkspaceMenu({ me, onDone }: { me: Me; onDone: () => void }): JSX.Element {
  const select = useSelectWorkspace();
  return (
    <>
      <div className={`${monoLabel} px-2.5 pt-2 pb-1`}>WORKSPACES</div>
      {me.workspaces.map((workspace) => {
        const current = workspace.id === me.workspace?.id;
        return (
          <button
            key={workspace.id}
            type="button"
            role="menuitemradio"
            aria-checked={current}
            disabled={current || select.isPending}
            onClick={() => {
              onDone();
              select.mutate({ id: workspace.id, name: workspace.name });
            }}
            className={item}
          >
            <span className="truncate">{workspace.name}</span>
            {current && <span className="text-acc text-xs">●</span>}
          </button>
        );
      })}
      <button
        type="button"
        role="menuitem"
        onClick={() => {
          onDone();
          window.dispatchEvent(new Event(NEW_WORKSPACE_EVENT));
        }}
        className={`${item} text-acc`}
      >
        + New workspace
      </button>
    </>
  );
}
